import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../stores/calculateStore";
import { ClientLegalGroup, ClientModel } from "../../../helpers/client";
import Header from "../header/header";
import Address from "../address/address";
import ToggleButtonGroupCustom from "../toggleButtonGroup/toggleButtonGroup";
import { yesNo } from "../../../helpers/yesNo";
import { runInAction } from "mobx";

interface ClientAddressProps {
  calculateStore?: CalculateStore;
  client: ClientModel;
  disabled?: boolean;
}

@inject("calculateStore")
@observer
export default class ClientAddress extends React.Component<ClientAddressProps> {

  public render() {
    const legalGroup = this.props.client.legalGroup;

    return (
      <div>
        {legalGroup === ClientLegalGroup.PERSON && this.renderPersonAddress()}
        {legalGroup === ClientLegalGroup.COMPANY && this.renderCompanyAddress()}
        {legalGroup === ClientLegalGroup.OTHER && this.renderCompanyAddress()}
        {this.renderContactAddress()}
      </div>
    );
  }

  private renderPersonAddress() {
    const shouldRenderQuestionTheSameAddress = this.props.calculateStore!.propertyInsuranceOrOcChecked;
    const shouldRenderAddressForm = this.props.client.personAddressTheSame && shouldRenderQuestionTheSameAddress;

    return (
      <div className="person-address">
        <Header type="small" mainHeader="Adres zamieszkania" />

        {shouldRenderQuestionTheSameAddress && (
          this.renderQuestionTheSameAddress("Czy adres taki sam jak ubezpieczanej nieruchomości?",
            this.props.client.personAddressTheSame,
            this.changePersonAddressValue.bind(this))
        )}

        {!shouldRenderAddressForm && (
          <Address address={this.props.client.personAddress} displayLabel={true}
            disabled={this.props.disabled}
          />
        )}
      </div>
    );
  }

  private renderCompanyAddress() {
    const shouldRenderQuestionTheSameAddress = this.props.calculateStore!.propertyInsuranceOrOcChecked;
    const shouldRenderAddressForm = this.props.client.companyAddressTheSame && shouldRenderQuestionTheSameAddress;

    return (
      <div className="company-address">
        <Header type="small" mainHeader="Adres siedziby przedsiębiorstwa" />

        {shouldRenderQuestionTheSameAddress && (
          this.renderQuestionTheSameAddress("Czy adres taki sam jak ubezpieczanej nieruchomości?",
            this.props.client.companyAddressTheSame,
            this.changeCompanyAddressValue.bind(this))
        )}

        {!shouldRenderAddressForm && (
          <Address address={this.props.client.companyAddress} displayLabel={true}
            disabled={this.props.disabled}
          />
        )}
      </div>
    );
  }

  private renderContactAddress() {
    const isPerson = this.props.client.legalGroup === ClientLegalGroup.PERSON;
    const question = isPerson ? "Czy adres taki sam jak zamieszkania?" : "Czy adres taki sam jak siedziby?";
    return (
      <div className="contact-address">
        <Header type="small" mainHeader="Adres korespondencyjny" />
        {this.renderQuestionTheSameAddress(
          question,
          this.props.client.contactAddressTheSame,
          this.changeContactAddressValue.bind(this))}

        {!this.props.client.contactAddressTheSame && (
          <Address address={this.props.client.contactAddress} displayLabel={true}
            disabled={this.props.disabled}
          />
        )}
      </div>
    );
  }

  private renderQuestionTheSameAddress(question: string, value: boolean, answerOnChange: (newValue: boolean) => void) {
    return (
      <ToggleButtonGroupCustom
        question={question}
        value={value ? yesNo.yes : yesNo.no}
        options={[{
          value: yesNo.yes,
          label: "TAK"
        }, {
          value: yesNo.no,
          label: "NIE"
        }]}
        onChange={(newValue) => {
          const newValueToBoolean = newValue === yesNo.yes;
          if (newValueToBoolean !== value) {
            answerOnChange(newValueToBoolean);
          }
        }}
        disabled={this.props.disabled}
      />
    );
  }

  private changePersonAddressValue(newValue: boolean) {
    runInAction(() => {
      // TODO: create setter and remove 'runInAction'
      this.props.client.personAddressTheSame = newValue;
    });
  }

  private changeCompanyAddressValue(newValue: boolean) {
    runInAction(() => {
      // TODO: create setter and remove 'runInAction'
      this.props.client.companyAddressTheSame = newValue;
    });
  }

  private changeContactAddressValue(newValue: boolean) {
    runInAction(() => {
      // TODO: create setter and remove 'runInAction'
      this.props.client.contactAddressTheSame = newValue;
    });
  }
}

